import { render, staticRenderFns } from "./OrderSkeleton.vue?vue&type=template&id=c4b3b1a0"
import script from "./OrderSkeleton.vue?vue&type=script&lang=js"
export * from "./OrderSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports